import React, { FC, useState } from 'react';

import { Menu, MenuItem, MenuProps, styled } from '@mui/material';
import Button from '@mui/material/Button';
import clsx from 'clsx';
import { Link } from 'react-router';

import styles from './styles.module.scss';

import ArrowDown from '@/assets/icons/arrow-down.svg?react';

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    {...props}
  />
))({
  '& .MuiPaper-root': {
    marginTop: 12,
    minWidth: 180,
    padding: 0,
    boxShadow: '0 2px 15px rgba(0, 0, 0, 0.05)',
  },
  '& .MuiList-root': {
    padding: 0,
  },
});

const StyledMenuItem = styled(MenuItem)({
  padding: 0,
  borderBottom: '1px solid #eff2f7',
});

export const CDFIResourcesSelect: FC<{ needHoverButtonEffect?: boolean }> = ({ needHoverButtonEffect }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        className={clsx(styles.button, needHoverButtonEffect && styles.hoverBtn)}
        disableRipple
        onClick={handleOpen}
        endIcon={<ArrowDown color="#2b39b9" />}
      >
        CDFI Resources
      </Button>

      <StyledMenu
        id="cdfi-resources-menu"
        slotProps={{
          list: {
            'aria-labelledby': 'cdfi-resources-menu',
          },
        }}
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
      >
        <StyledMenuItem onClick={handleClose} disableRipple>
          <Link className={styles.option} to={import.meta.env.VITE_CDFI_BENEFITS_URL} target="_blank">
            Benefits
          </Link>
        </StyledMenuItem>

        <StyledMenuItem onClick={handleClose} disableRipple>
          <Link
            className={styles.option}
            to={import.meta.env.VITE_CDFI_LOAN_ORIGINATION_UPLOAD_GUIDE_URL}
            target="_blank"
          >
            Loan Origination Upload Guide
          </Link>
        </StyledMenuItem>
      </StyledMenu>
    </>
  );
};
